export enum ProductRequestStatus {
    Pending = 0,
    Ok = 1,
    Cancel = 2,
    Reject = 3,
    Waiting = 4,
    Onprocess = 5,
    Delivery = 6,
    KirimKeCabang = 7,
    WaitingApproval = 8,
    Close = 9,
    Approved = 10
}